//样式
import './assets/css/theme-green.scss'
import './assets/css/theme-blue.scss'
//配置
import './config.js'
//
import Home from './Home'
//order
import HistoryAnalyse from './order/HistoryAnalyse'
import TodayOrder from './order/TodayOrder'
import TaskDetail from './order/TaskDetail'
//stock
import StockChart1 from './stock/StockChart1'
import StockChart2 from './stock/StockChart2'
import StockChart3 from './stock/StockChart3'
//device
// 数据分析
import DeviceTotal from './device/DeviceTotal'

import DeviceMaintain from './device/DeviceMaintain'
import DeviceMaintainTime from './device/DeviceMaintainTime'
import DeviceMaintainFault from './device/DeviceMaintainFault'
import DeviceMaintainFaultTime from './device/DeviceMaintainFaultTime'
import DeviceMaintainEnergy from './device/DeviceMaintainEnergy'

import DeviceDetailTimeStatistics from './device/DeviceDetailTimeStatistics'
import DeviceDetailFaultAnalysis from './device/DeviceDetailFaultAnalysis'
import DeviceDetailMaintenanceRecord from './device/DeviceDetailMaintenanceRecord'
//digitalarea
import RealtimeAlarm from './digitalarea/RealtimeAlarm'
import RealtimeAlarmOne from './digitalarea/RealtimeAlarmOne'
import TurnoverRatio from './digitalarea/TurnoverRatio'
import DigitalTodayOrder from './digitalarea/TodayOrder'


// 龙岩页面
import LyHome from './home/Home'    //  首页(设备维保主页面)
import LyHomeDetails from './home/HomeDetails'    //  首页(设备维保详情)
import LyLogin from './home/Login'  //登录页
import LyNumber from './home/Number'  //数字库区
import LyStock from './home/Stock'  //库存管理
import LyOrder from './home/Order'  //订单管理

import Demo from './home/demo'  //库存测试


//路由列表

export const xiayanRouter = [
  { 
    path: '/',
    name: 'LyLogin',
    component: LyLogin
  },
  {   //设备维保
    path: '/home',
    name: 'LyHome',
    component: LyHome,
  },
  {   //设备维保
    path: '/totals',
    name: 'DeviceTotal',
    component: DeviceTotal,
  },
  {
    path: '/home/details',
    name: 'LyHomeDetails',
    component: LyHomeDetails,
  },
  {   //数字库区
    path: '/number',
    name: 'LyNumber',
    component: LyNumber
  },
  {   //库存管理
    path: '/stock',
    name: 'LyStock',
    component: LyStock
  },
  {   //订单管理
    path: '/order',
    name: 'LyOrder',
    component: LyOrder
  },
  {
    path: '/order/task-detail',  //任务详情
    name: 'TaskDetail',
    component: TaskDetail
  },
  {
    path: '/demo',  //任务详情
    name: 'Demo',
    component: Demo
  },
]
// export const xiayanRouter = [
//     {
//       path: '/',
//       name: 'home',
//       redirect: {name: 'TodayOrder'}
//     },
//     {
//       path: '/charts',
//       name: 'charts',
//       redirect: {name: 'TodayOrder'},
//       component: Home,
//       meta: {
//         //title: '图表'
//       },
//       children: [
//         {   //设备维保
//           path: 'home',
//           name: 'LyHome',
//           component: LyHome
//         },
//         {
//           path: 'order/today-order',
//           name: 'TodayOrder',
//           component: TodayOrder
//         },
//         {
//           path: 'order/task-detail',  //任务详情
//           name: 'TaskDetail',
//           component: TaskDetail
//         },

//         {
//           path: 'stock/chart1',
//           name: 'StockChart1',
//           component: StockChart1
//         },
//         {
//           path: 'stock/chart2',
//           name: 'StockChart2',
//           component: StockChart2
//         },
//         {
//           path: 'stock/chart3',
//           name: 'StockChart3',
//           component: StockChart3
//         },
//         {
//           path: 'device/total',
//           name: 'DeviceTotal',
//           component: DeviceTotal
//         },
//         {
//           path: 'device/maintain',
//           name: 'DeviceMaintain',
//           component: DeviceMaintain
//         },
//         {
//           path: 'device/maintain-time',
//           name: 'DeviceMaintainTime',
//           component: DeviceMaintainTime
//         },
//         {
//           path: 'device/maintain-fault',  //故障汇总 周月日
//           name: 'DeviceMaintainFault',
//           component: DeviceMaintainFault
//         },
//         {
//           path: 'device/maintain-fault-time', //周月日
//           name: 'DeviceMaintainFaultTime',
//           component: DeviceMaintainFaultTime
//         },
//         {
//           path: 'device/maintain-energy', //故障汇总
//           name: 'DeviceMaintainEnergy',
//           component: DeviceMaintainEnergy
//         },
//         {
//           path: 'device/maintain-record', //故障清单
//           name: 'DeviceMaintainRecord',
//           component: DeviceMaintainRecord
//         },
//         {
//           path: 'device/detail-time-statistics',  //早中晚班
//           name: 'DeviceDetailTimeStatistics',
//           component: DeviceDetailTimeStatistics
//         },
//         {
//           path: 'device/detail-fault-analysis', //停机分析
//           name: 'DeviceDetailFaultAnalysis',
//           component: DeviceDetailFaultAnalysis
//         },
//         {
//           path: 'device/detail-maintenance-record', //维修保养记录
//           name: 'DeviceDetailMaintenanceRecord',
//           component: DeviceDetailMaintenanceRecord
//         },

//         {
//           path: 'digitalarea/realtime-alarm',//实时报警
//           name: 'RealtimeAlarm',
//           component: RealtimeAlarm
//         },
//         {
//           path: 'digitalarea/realtime-alarm-one',//历史报警
//           name: 'RealtimeAlarmOne',
//           component: RealtimeAlarmOne
//         },
//         {
//           path: 'digitalarea/turnover-ratio',
//           name: 'TurnoverRatio',
//           component: TurnoverRatio
//         },
//         {
//           path: 'digitalarea/today-order',  //任务总量
//           name: 'DigitalTodayOrder',
//           component: DigitalTodayOrder
//         },
//       ]
//     }
// ];


// WEBPACK FOOTER //
// ./src/components/xiayan/router.js